import { Injectable } from '@angular/core';
import { User } from '../models/user';
import { Project } from '../../project/models/project';
import { CookieService } from 'ngx-cookie-service';
import { EnvironmentConfigService } from '../../../core/services/environment-config.service';

@Injectable({
  providedIn: 'root'
})
export class UserProfileService {

  currentUser: User;
  
  currentUnit: string = 'metric';
  currentTimezone: any;
  currentLocale: string;
  currentLanguage: string;

  selectedProject: Project;

  today: Date = new Date();

  debug: boolean = false;

  constructor(
    private cookieService: CookieService,
    private environmentConfigService: EnvironmentConfigService
  ) { }

  init = () => {
    /*
      setLanguage();
      setMetrics();
      setTimeZone();
      setLocale();
    */
  }

  getUserData = (): User | null => {
    const userData = localStorage.getItem("nomad.noc.ng.user");
    return userData ? <User>JSON.parse(userData) : null;
  }

  getProfile = (propertyName: string) => {
    return this.cookieService.get(propertyName);
  }

  updateProfile = (propertyName: string, value: string) => {
    this.cookieService.set(propertyName, value, { 
      secure: this.environmentConfigService.get("secureCookies") 
    })
  }

  isAdmin = (): boolean => {
    const userData = this.getUserData();
    return userData ? userData.admin : false;
  }

  hasPageAccess = (projectId: number, pageId: string): boolean => {
    const userData = this.getUserData();
    return userData && userData.admin ? true : !!(userData && userData.projectPageSet && userData.projectPageSet[projectId] && userData.projectPageSet[projectId].find(projectPage => projectPage.name === pageId));  
  }
}
